import { FC, useEffect, useState } from 'react';
import { Typography } from 'antd';
import { TbInfoCircleFilled } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlatformAlert } from '@/shared/components/alerts';
import { BillingSnapshotContract } from '@/stores/database/aliases/billing/types';

interface HeadingProps {
    snapshot: BillingSnapshotContract;
}

const Heading: FC<HeadingProps> = ({ snapshot }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <Typography.Title id='settings-account-plans-billing-section' level={4} style={{ marginBottom: 0 }}>
                Billing
            </Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                View your invoice & manage your billing below.
            </Typography.Paragraph>
            {snapshot?.subscription?.cancelAtPeriodEnd && (
                <PlatformAlert
                    showIcon
                    type='warning'
                    icon={<TbInfoCircleFilled />}
                    message='Subscription cancelled'
                    description='Your plan will remain active through the end of the current billing period.'
                    style={{ marginTop: '1rem' }}
                />
            )}
        </>
    );
};

export default Heading;
